export default "__VITE_ASSET__CwLiRcAf__"